export const USE_ORDER_SOURCE_HEADER_MAPI = "use-order-source-header-MAPI";
export const USE_ORDER_SOURCE_HEADER_OAPI = "use-order-source-header-OAPI";
export const SENTRY_REPLAYS = "sentry-replays";
export const SENTRY_REPLAY_CONFIG = "sentry-replay-config";
export const SEND_ANALYTICS_EVENTS = "send-analytics-events";
export const PICKUP_TIME_AUTO_SELECT_ENABLED = "pickup-time-auto-select-enabled";
